import { SegmentedControl } from "@mantine/core";

import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { Modal } from "@mantine/core";
import { Select } from "@mantine/core";
import Swal from "sweetalert2";
// import { Pagination } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import DialogContentText from "@mui/material/DialogContentText";

// import Pagination from "react-bootstrap/Pagination";
// import apiInstance from '../../../../Utils/api.js'
import BASE_API_URL from "../../../../api/api.js";
import {
  FaCashRegister,
  FaFileMedical,
  FaPenSquare,
  FaPaperPlane,
  FaRegEdit,
  FaRegTrashAlt,
} from "react-icons/fa";
import axios from "axios";
import apiInstance from "../../../../Utils/api.js";
import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { EyeIcon, RotateCcw, XIcon } from "lucide-react";
import { usePost } from "../../../../hooks/usePost.js";
export const Voucher = () => {
  const [show, setShow] = useState("");
  const [cancelDate, setCancelDate] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState("");
  const [branchLists, setBranchLists] = useState([]);
  const [reason, setReason] = useState("");
  const [showBox, setShowBox] = useState(false);
  const [voucherCode, setVoucherCode] = useState("");
  const [voucherID, setVoucherID] = useState("");
  const [dataSelect, setDataSelect] = useState("");
  const [customerLists, setCustomerLists] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [searchList, setSearchList] = useState([]);
  const [relatedBranch, setRelatedBranch] = useState("");
  const [branch, setBranch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedVoucher, setSelectedVoucher] = useState(null);
  const url = BASE_API_URL;
  const token = localStorage.getItem("token");
  const api = apiInstance;
  const [approveModal, setApproveModal] = useState({
    open: false,
    refund: null,
  });

  const {
    loading: postLoading,
    data,
    postData,
  } = usePost(`ho/refund/treatment-voucher/${approveModal.refund ?? null}`);

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const handleMenuClick = (event, voucher) => {
    setAnchorEl(event.currentTarget);
    setSelectedVoucher(voucher);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedVoucher(null);
  };

  const handleView = () => {
    navigate(`/voucher/${selectedVoucher?._id}`);
    handleMenuClose();
  };

  const handleRefund = () => {
    // setApproveModal({ open: true, refund: selectedVoucher?._id });
    // handleMenuClose();
    navigate(`/voucher/refund/${selectedVoucher?._id}`);
  };

  const handleCancel = () => {
    setVoucherCode(selectedVoucher.code);
    setVoucherID(selectedVoucher._id);
    setBranch(selectedVoucher.relatedBranch);
    setShowBox(true);
    handleMenuClose();
  };

  console.log(approveModal);

  const navigate = useNavigate();

  const handleConfirmCancelVoucher = async () => {
    try {
      const response = await api.put("head-office/cancel", {
        voucherID,
        relatedBranch: branch,
        reason,
        cancelDate,
      });
      console.log("response:", response);
      Swal.fire({
        title: "Deleted!",
        text: "The treatment has been deleted successfully.",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
      });
      setShowBox(false);
      setTimeout(() => {
        handleSearch();
      }, 1000);
    } catch (err) {
      Swal.fire({
        title: "Error!",
        text: err.response?.data?.message || "Something went wrong.",
        icon: "error",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  const handleSearch = async () => {
    try {
      console.log("correct");
      const params = {
        perPage: rowsPerPage,
        startDate,
        endDate,
        relatedBranch,
        relatedPatient: dataSelect,
      };

      if (show === "mTable") {
        params.tsType = "MS";
      } else if (show === "tmTable") {
        params.tsType = "TSMulti";
      } else if (show === "isCancel") {
        params.isCancel = true;
      }
      console.log("Posting Successful");
      setLoading(true);

      const res = await api.get(`head-office/vouchers?page=${currentPage}`, {
        params,
      });

      console.log(res.data, "Filtered Vouchers");
      setLoading(false);
      setSearchList(res.data.data);
      setTotalPage(res?.data?.metadata.pageCount);
      setCurrentPage(res?.data?.metadata.currentPage);
      setShowSearch(true);
    } catch (err) {
      Swal.fire({
        title: "Error!",
        text: err.response?.data?.message || "Something went wrong.",
        icon: "error",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  const confirmApprove = async () => {
    await postData({});
    setApproveModal({ open: false, refund: null });
  };
  const closeApproveModal = () => {
    setApproveModal({ open: false, refund: null });
  };

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setCancelDate(today);

    const getStockReqLists = async () => {
      try {
        const res = await api.get("head-office/patients");

        console.log(res.data, "patient");
        setCustomerLists(res.data.data);
      } catch (err) {
        alert(err.message);
      }
    };

    const getBranches = async () => {
      try {
        const res = await api.get("head-office/branches");
        setBranchLists(res.data.data);
      } catch (err) {
        alert(err.message);
      }
    };

    getBranches();
    getStockReqLists();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [rowsPerPage]);

  useEffect(() => {
    handleSearch();
  }, [currentPage]);

  return (
    <>
      {/* @include('sweet::alert') */}

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item active">Voucher List</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <div className="card mt-2 ml-2">
            <div className="card-header">
              <div className="">
                <label htmlFor="options">Select an option:</label>
                <select
                  id="options"
                  className="mb-3 p-2 form-select w-25"
                  value={show}
                  onChange={(e) => setShow(e.target.value)}
                >
                  <option value="all">All</option>
                  <option value="mTable">Medicine</option>
                  <option value="tmTable">Treatment</option>
                  <option value="isCancel">Cancel</option>
                </select>
              </div>
            </div>
            <div className="row py-3">
              <div className="row ml-2 col-md-10">
                <div className="form-group col-md-2">
                  <label>From</label>
                  <input
                    type="date"
                    name="from"
                    id="from"
                    className="form-control"
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </div>
                <div className="form-group col-md-2">
                  <label>To</label>
                  <input
                    type="date"
                    name="to"
                    id="to"
                    className="form-control"
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>
                <div
                  className=" form-group col-md-2"
                  style={{ marginTop: "2em" }}
                >
                  <Select
                    data={[
                      { value: "", label: "All" },
                      ...customerLists.map((option) => ({
                        value: option._id,
                        label: option.name,
                      })),
                    ]}
                    placeholder="Customer"
                    searchable
                    value={dataSelect}
                    onChange={setDataSelect}
                    classNames={{ input: "border-info" }}
                  />
                </div>
                <div
                  className="form-group col-md-2"
                  style={{ marginTop: "2.4em" }}
                >
                  <select
                    className="custom-select border-info"
                    onChange={(e) => setRelatedBranch(e.target.value)}
                  >
                    <option hidden>Filter By Branch</option>
                    <option value="">All</option>
                    {branchLists.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div
                  className="form-group col-md-2"
                  style={{ marginTop: "2.4em" }}
                >
                  <Button
                    type="button"
                    className="btn btn-primary"
                    size="sm"
                    onClick={() => handleSearch(true)}
                  >
                    Search
                  </Button>
                </div>
              </div>
              <div className="row col-md-2">
                <label htmlFor="options">Per Page</label>
                <select
                  id="options"
                  className="mb-3 p-2 form-select w-50"
                  value={rowsPerPage}
                  onChange={(e) => setRowsPerPage(e.target.value)}
                >
                  <option value="20">20</option>
                  <option value="40">40</option>
                  <option value="60">60</option>
                  <option value="80">80</option>
                  <option value="100">100</option>
                </select>
              </div>
            </div>
          </div>

          {/* Model Section */}
          <Modal
            opened={showBox}
            onClose={() => setShowBox(false)}
            title="Voucher Details"
            centered
            size="lg"
          >
            <div className="m-4">
              <div className="form-group ">
                <label>Voucher Code</label>
                <input
                  type="text"
                  className="form-control"
                  value={voucherCode}
                  onChange={(e) => setVoucherCode(e.target.value)}
                  disabled
                />
              </div>

              <div className="form-group w-50">
                <label>Date</label>
                <input
                  type="date"
                  name="date"
                  className="form-control"
                  value={cancelDate}
                  onChange={(e) => setCancelDate(e.target.value)}
                />
              </div>

              <div className="form-group mt-3">
                <label>Reason</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Enter description"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                ></textarea>
              </div>

              <div className="mt-4 text-end">
                <Button
                  variant="light"
                  color="gray"
                  onClick={() => setShowBox(false)}
                  className="mr-2"
                >
                  Close
                </Button>
                <Button
                  className="btn btn-primary"
                  onClick={handleConfirmCancelVoucher}
                >
                  Confirm
                </Button>
              </div>
            </div>
          </Modal>
          {/* /Model Section */}

          {/* Table */}
          <div className="card mt-2 ml-2">
            <div className="row">
              <div className="col-md-12">
                <Box
                  sx={{
                    overflowX: "auto",
                    width: "100%",
                    display: "inline-block",
                  }}
                ></Box>
                <TableContainer
                  component={Paper}
                  sx={{
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    borderRadius: 2,
                  }}
                >
                  <Table
                    sx={{
                      minWidth: 1200,
                      "& .MuiTableCell-head": {
                        backgroundColor: "#f8f9fa",
                        fontWeight: 600,
                        fontSize: "14px",
                        color: "#495057",
                        borderBottom: "2px solid #dee2e6",
                      },
                      "& .MuiTableCell-body": {
                        fontSize: "14px",
                        padding: "12px 16px",
                        "&:hover": {
                          backgroundColor: "#f8f9fa",
                        },
                      },
                      "& .MuiTableRow-root": {
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      },
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ width: "60px" }}>#</TableCell>
                        <TableCell sx={{ width: "120px" }}>Date</TableCell>
                        <TableCell sx={{ width: "140px" }}>Code</TableCell>
                        <TableCell sx={{ width: "180px" }}>
                          CustomerName
                        </TableCell>
                        <TableCell sx={{ width: "140px" }}>
                          CustomerPhone
                        </TableCell>
                        <TableCell sx={{ width: "160px" }}>Doctor</TableCell>
                        <TableCell sx={{ width: "130px" }}>
                          TotalAmount
                        </TableCell>
                        <TableCell sx={{ width: "130px" }}>
                          PaidAmount
                        </TableCell>
                        <TableCell sx={{ width: "130px" }}>
                          RefundAmount
                        </TableCell>
                        <TableCell sx={{ width: "120px" }}>Balance</TableCell>
                        <TableCell sx={{ width: "140px" }}>
                          PaymentMethod
                        </TableCell>
                        {show !== "isCancel" && (
                          <TableCell sx={{ width: "120px" }}>Action</TableCell>
                        )}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {loading ? (
                        <TableRow>
                          <TableCell
                            colSpan={show !== "isCancel" ? 13 : 12}
                            sx={{
                              textAlign: "center",
                              padding: "40px 16px",
                              backgroundColor: "#fafafa",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: 2,
                              }}
                            >
                              <Skeleton
                                variant="rectangular"
                                width={40}
                                height={40}
                                sx={{ borderRadius: 1 }}
                              />
                              <Skeleton
                                variant="text"
                                width={120}
                                height={24}
                              />
                              <Skeleton variant="text" width={80} height={20} />
                            </Box>
                          </TableCell>
                        </TableRow>
                      ) : showSearch && searchList.length > 0 ? (
                        searchList.map((sq, i) => (
                          <TableRow
                            key={sq._id}
                            sx={{
                              "&:hover": {
                                backgroundColor: "#f8f9fa",
                                cursor: "pointer",
                              },
                              transition: "background-color 0.2s ease",
                            }}
                          >
                            <TableCell sx={{ fontWeight: 500 }}>
                              {(currentPage - 1) * rowsPerPage + i + 1}
                            </TableCell>
                            <TableCell>
                              {sq.createdAt ? sq.createdAt.split("T")[0] : ""}
                            </TableCell>
                            <TableCell
                              sx={{ fontFamily: "monospace", fontWeight: 500 }}
                            >
                              {sq.code}
                            </TableCell>
                            <TableCell sx={{ fontWeight: 500 }}>
                              {sq.relatedPatient?.name}
                            </TableCell>
                            <TableCell>{sq.relatedPatient?.phone}</TableCell>
                            <TableCell>{sq.relatedDoctor?.name}</TableCell>

                            {sq.tsType === "MS" ? (
                              <>
                                <TableCell
                                  sx={{ fontWeight: 500, color: "#2e7d32" }}
                                >
                                  {sq.msTotalAmount?.toLocaleString()}
                                </TableCell>
                                <TableCell
                                  sx={{ fontWeight: 500, color: "#1976d2" }}
                                >
                                  {sq.msPaidAmount?.toLocaleString()}
                                </TableCell>
                              </>
                            ) : (
                              <>
                                <TableCell
                                  sx={{ fontWeight: 500, color: "#2e7d32" }}
                                >
                                  {sq.totalAmount?.toLocaleString()}
                                </TableCell>
                                <TableCell
                                  sx={{ fontWeight: 500, color: "#1976d2" }}
                                >
                                  {sq.totalPaidAmount?.toLocaleString()}
                                </TableCell>
                              </>
                            )}
                            <TableCell sx={{ color: "#ed6c02" }}>
                              {sq.refundAmount?.toLocaleString()}
                            </TableCell>
                            <TableCell
                              sx={{
                                fontWeight: 600,
                                color: sq.balance > 0 ? "#d32f2f" : "#2e7d32",
                              }}
                            >
                              {sq.balance?.toLocaleString()}
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "inline-block",
                                  px: 1.5,
                                  py: 0.5,
                                  borderRadius: 1,
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  backgroundColor: "#e3f2fd",
                                  color: "#1565c0",
                                }}
                              >
                                {sq.paymentMethod}
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Button
                                onClick={(event) => handleMenuClick(event, sq)}
                                size="small"
                                variant="outlined"
                                endIcon={<KeyboardArrowDownIcon />}
                                sx={{
                                  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                                  "&:hover": {
                                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                    backgroundColor: "#f5f5f5",
                                  },
                                  textTransform: "none",
                                  fontSize: "13px",
                                }}
                              >
                                Actions
                              </Button>
                              <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleMenuClose}
                                sx={{
                                  "& .MuiMenuItem-root": {
                                    flexGrow: 1,
                                  },
                                }}
                                slotProps={{
                                  paper: {
                                    elevation: 0,
                                    sx: {
                                      mt: 1,
                                      borderRadius: 2,
                                      minWidth: 140,
                                      fontSize: 12,
                                      border: "1px solid #f0f0f0",
                                    },
                                  },
                                }}
                              >
                                <MenuItem onClick={handleView}>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "0.5rem",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    <EyeIcon className="size-20" />
                                    View
                                  </Typography>
                                </MenuItem>

                                {!selectedVoucher?.Refund && (
                                  <MenuItem onClick={handleRefund}>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "0.5rem",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      <RotateCcw className="size-20" />
                                      Refund
                                    </Typography>
                                  </MenuItem>
                                )}

                                {show !== "isCancel" && (
                                  <MenuItem onClick={handleCancel}>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "0.5rem",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      <XIcon className="size-20" />
                                      Cancel
                                    </Typography>
                                  </MenuItem>
                                )}
                              </Menu>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={show !== "isCancel" ? 13 : 12}
                            sx={{
                              textAlign: "center",
                              padding: "60px 16px",
                              backgroundColor: "#fafafa",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <Typography
                                variant="h6"
                                sx={{
                                  color: "#666",
                                  fontWeight: 500,
                                  mb: 1,
                                }}
                              >
                                No data found
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  color: "#999",
                                  fontSize: "14px",
                                }}
                              >
                                Try adjusting your search filters or check back
                                later
                              </Typography>
                            </Box>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center py-3">
            <Stack spacing={2}>
              <Pagination
                count={totalPage}
                page={currentPage}
                onChange={handlePageChange}
              />
            </Stack>
          </div>
        </div>

      {/* Approve Confirmation Modal */}
      <Dialog
        open={approveModal.open}
        onClose={closeApproveModal}
        aria-labelledby="approve-dialog-title"
        aria-describedby="approve-dialog-description"
      >
        <DialogTitle id="approve-dialog-title">
          Confirm Refund Approval
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="approve-dialog-description">
            Are you sure you want to approve this refund request?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={closeApproveModal}
            color="secondary"
            disabled={postLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={confirmApprove}
            variant="contained"
            sx={{
              backgroundColor: "#4caf50",
              "&:hover": { backgroundColor: "#45a049" },
            }}
            autoFocus
            disabled={postLoading}
          >
            {postLoading ? (
              <CircularProgress size={20} sx={{ color: "white" }} />
            ) : (
              "Approve"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
